module.exports = __webpack_public_path__ + "img/image1.d7a363e0.jpeg";